import { NgModule } from "@angular/core";
import { CommonModule, NgOptimizedImage } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

// SERVICES
import { AuthGuard } from "./services/auth/auth.guard";
import { AppLoaderService } from "./services/app-loader/app-loader.service";
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from "@angular/common/http";
import { EmailService } from "./services/email.service";
import { HeaderComponent } from "../views/home/header/header.component";
import { FooterComponent } from "../views/home/footer/footer.component";
import { MatListModule } from "@angular/material/list";
import { MatIconModule } from "@angular/material/icon";
import { WINDOW_PROVIDERS } from "./helpers/window.helper";
import { SharedDirectivesModule } from "./directives/shared-directives.module";
import { SharedComponentsModule } from "./components/shared-components.module";
import { SharedMaterialModule } from "./shared-material.module";
import { ErrorDialogComponent } from "./components/error-dialog.component";
import { ScrollToDirective } from "./directives/scroll-to.directive";
const classesToInclude = [HeaderComponent, FooterComponent, ScrollToDirective];

@NgModule({
  declarations: [classesToInclude, ErrorDialogComponent],
  exports: [classesToInclude],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MatListModule,
    MatIconModule,
    ReactiveFormsModule,
    SharedDirectivesModule,
    SharedComponentsModule,
    SharedMaterialModule,
    NgOptimizedImage,
  ],
  providers: [
    AuthGuard,
    AppLoaderService,
    EmailService,
    WINDOW_PROVIDERS,
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class SharedModule {}
